import { useCallback } from 'react'
import { useNavigate } from '@tanstack/react-router'
import useLoginStore from '@/store/LoginStore'

/** Expand (⤢) from the modal or side panel to the task's full page (design 16b). */
export function useOpenTaskPage() {
  const navigate = useNavigate()
  const workspaceSlug = useLoginStore((state) => state.workspaceSlug)
  return useCallback(
    (taskId: string) => {
      if (!workspaceSlug) return
      void navigate({ to: '/$workspaceSlug/tasks/$taskId', params: { workspaceSlug, taskId } })
    },
    [navigate, workspaceSlug],
  )
}
